import { render, staticRenderFns } from "./employeeInductionList.vue?vue&type=template&id=8fed04da&scoped=true"
import script from "./employeeInductionList.vue?vue&type=script&lang=js"
export * from "./employeeInductionList.vue?vue&type=script&lang=js"
import style0 from "./employeeInductionList.vue?vue&type=style&index=0&id=8fed04da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fed04da",
  null
  
)

export default component.exports